import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { OrganisationService, ToolAppKey } from '../organisation.service';

@Injectable({ providedIn: 'root' })
export class ToolAccessGuard implements CanActivate {
    constructor(
        private orgService: OrganisationService,
        private router: Router,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        const requiredApp = route.data['requiredApp'] as ToolAppKey | undefined;
        if (!requiredApp) {
            return true;
        }

        if (!this.orgService.isAppEnabledForCurrentOrg(requiredApp)) {
            this.orgService.setActiveApp(null);
            this.router.navigate(['/']);
            return false;
        }

        this.orgService.setActiveApp(requiredApp);
        return true;
    }
}
